/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

/** @description import Global or some other files only if you need them */
// import Global from '../shared/global';

'use strict';
const jobApplication = {

	$jsSpanCompanyName: $('.js-span-job-company-name'),
	$jsSpanJobName: $('.js-span-job-job-name'),
	$jsInputCompanyName: $('.js-input-job-application-company-name'),
	$jsInputJobName: $('.js-input-job-application-job-name'),
	$jsInputJobLocation: $('.js-input-job-location-name'),
	$jsJobID: $('.js-input-job-application-post-id'),

	init: function() {
		const _this = this;
		$(document).ready(function() {
			if ($('.single-cpt_job').length) {
				_this.populateData();
			}
		});
	},

	populateData: function() {
		const title = $('.text-hero__page-title').text();
		const companyName = $('.js-company-name').text();
		const jobLocation = $('.js-job-location').text();
		const id = $('.js-company-name').data('id');

		jobApplication.$jsSpanJobName.text(title);
		jobApplication.$jsInputJobName.val(title);

		jobApplication.$jsSpanCompanyName.text(companyName);
		jobApplication.$jsInputCompanyName.val(companyName);
		jobApplication.$jsInputJobLocation.val(jobLocation);
		jobApplication.$jsJobID.val(id);
	}
};

export default jobApplication;
